import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReportsService } from 'src/app/_services/reports.service';

@Component({
  selector: 'app-delay-report',
  templateUrl: './delay-report.component.html',
  providers: [DatePipe],
})
export class DelayReportComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  data: any;
  users = [];
  summary = [];
  subscriptions: Subscription[] = [];
  form: FormGroup;

  constructor(
    private reportsService: ReportsService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      date_from: ['', Validators.required],
      date_to: ['', Validators.required],
    });

    // this.getData('2023-03-01', '2023-09-18');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getData(dateFrom, dateTo) {
    this.data = [];
    this.loading = true;
    this.subscriptions.push(
      this.reportsService
        .getDelayReport(dateFrom, dateTo)
        .subscribe((responseData: any) => {
          this.data = responseData;
          this.users = responseData.users;
          this.summary = [responseData.summary];
        })
    );
  }

  onSearch() {
    const form = this.form.getRawValue();

    if (this.form.valid) {
      form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
      form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');

      this.getData(form.date_from, form.date_to);
    }
  }

  onExportPdf() {
    const form = this.form.getRawValue();
    form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
    form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');
    this.subscriptions.push(
      this.reportsService
        .exportDelayToPDF(form.date_from, form.date_to)
        .subscribe((pdfHref) => {
          window.open(pdfHref.href, '_blank');
        })
    );
  }

  /* ====================================
   *             HELPERS
   ======================================= */

  clearFilters(controlName) {
    this.form.get(controlName).setValue('');
  }
}
